export type UserSchema = {
  token: string;
  id: string;
  email: string;
  username: string;
  firstName: string;
  lastName: string;
};

export enum ActiveTabEnum {
  Home = "Home",
  Transport = "Transport",
  Accommodation = "Accommodation",
  Activity = "Activity",
}

export enum TripType {
  Transport = "transport",
  Accommodation = "accommodation",
  Activities = "activities",
}

export enum TripItemType {
  Transparent = "transparent",
  Background = "background",
}

export type ItineraryItemSchema = {
  id: string;
  createdId: string;
  name: string;
  completed: boolean;
  location: string;
  time: string;
  cost: Cost;
  trips: TripItemSchema[];
};

export type TripItemSchema = {
  id: string;
  createdId: string;
  name: string;
  type: TripType;
  start: DateTimeSchema;
  end: DateTimeSchema;
  cost: Cost;
  booking: Booking;
  completed: boolean;
};

export type Cost = {
  totalValue: number;
  currency: string;
  userValue: number;
  userCurrency: string;
};

export type Booking = unknown;

export type DateTimeSchema = {
  location: string;
  time: string;
};
